import * as React from 'react';

import {File} from 'shells/files/file';

const INLINE_FILETYPES = ['pdf'];

type Props = {
    isEmailAttachment?: boolean;
    file: any;
};

/*
 * Backbone wrapper around a shells/file component. Handles
 * external file changes, model updates, etc.
 */
export class BackboneFileWrapper extends React.Component<Props> {
    componentDidMount() {
        this.props.file.on('change', this.rerender);
    }

    componentWillUnmount() {
        this.props.file.off('change', this.rerender);
    }

    rerender = () => {
        this.forceUpdate();
    };

    render() {
        const file = this.props.file;
        const creator = file.get('creator');
        const filename = file.get('filename');
        const href = formatFileUrl(file);

        const isProcessing =
            !this.props.isEmailAttachment &&
            (file.get('status') === 'pending' || !file.get('isAvailable'));

        const hasTimedOut = file.hasTimedOut();

        return (
            <File
                id={file.id}
                href={href}
                filename={filename}
                filetype={file.get('filetype')}
                creatorName={creator ? creator.get('name') : undefined}
                createdTime={file.get('createdTime')}
                onReprocessFile={this.reprocessFile}
                onConfirmDelete={this.handleDeleteFile}
                isProcessing={isProcessing}
                hasTimedOut={hasTimedOut}
            />
        );
    }

    handleDeleteFile = () => {
        this.props.file.destroy({wait: true});
    };

    reprocessFile = () => {
        this.props.file.reprocessFile();
    };
}

// @ts-expect-error
function formatFileUrl(file) {
    const disposition = INLINE_FILETYPES.includes(file.get('filetype')) ? 'inline' : 'attachment';

    return file.isNew() ? '#' : `${file.url()}?disposition=${disposition}`;
}
